// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bafd7b77","455":"44692ccc","977":"f2163bc1"}[chunkId] + ".chunk.js";
};